// inactivityTimer.js
let timeoutId;
const TIMEOUT_DURATION = 60 * 60 * 1000; // 60 minutes

export function startInactivityTimer(callback) {
  const reset = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(callback, TIMEOUT_DURATION);
  };

  // Listen for activity
  ['click', 'mousemove', 'keydown', 'scroll'].forEach(event =>
    window.addEventListener(event, reset)
  );

  reset(); // start initially
}

export function clearInactivityTimer() {
  clearTimeout(timeoutId);
  ['click', 'mousemove', 'keydown', 'scroll'].forEach(event =>
    window.removeEventListener(event, clearInactivityTimer)
  );
}